// Must be the div id where you want the form to be loaded
export const INSTANCE_ID = 'urx-form';

// The required urx form-id to be embedded
export const FORM_ID = 'QTE-securityrandori';
